import { render, staticRenderFns } from "./marka.vue?vue&type=template&id=621e9691&scoped=true&"
import script from "./marka.vue?vue&type=script&lang=js&"
export * from "./marka.vue?vue&type=script&lang=js&"
import style0 from "./marka.vue?vue&type=style&index=0&id=621e9691&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621e9691",
  null
  
)

export default component.exports